import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Eye } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { errMsg } from "@/lib/api";
import { useAuth, googleLogin } from "@/lib/auth";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(() => sessionStorage.getItem("login_error") || "");
  useEffect(() => {
    sessionStorage.removeItem("login_error");
  }, []);
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
    } catch (err) {
      setError(errMsg(err));
    }
    setBusy(false);
  };

  return (
    <div className="min-h-screen grid place-items-center bg-slate-50 px-4" data-testid="login-page">
      <form onSubmit={submit} className="w-full max-w-sm bg-white border border-slate-200 rounded-lg p-8 space-y-4 fade-up">
        <div className="flex items-center gap-2 mb-2">
          <div className="h-9 w-9 rounded-md bg-[#0D9488] grid place-items-center"><Eye className="h-5 w-5 text-white" /></div>
          <div>
            <div className="font-[Outfit] font-bold text-slate-900">Flujo Pacientes</div>
            <div className="text-xs text-slate-500">Acceso del equipo</div>
          </div>
        </div>
        <Input data-testid="login-email" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        <Input data-testid="login-password" type="password" placeholder="Contraseña" value={password} onChange={(e) => setPassword(e.target.value)} required />
        {error && <p className="text-sm text-rose-600" data-testid="login-error">{error}</p>}
        <Button data-testid="login-submit" type="submit" disabled={busy} className="w-full bg-[#1E3A8A] hover:bg-[#1E40AF]">{busy ? "Entrando…" : "Entrar"}</Button>
        <div className="flex items-center gap-3 text-xs text-slate-400"><span className="h-px flex-1 bg-slate-200" />o<span className="h-px flex-1 bg-slate-200" /></div>
        <button type="button" onClick={googleLogin} data-testid="login-google" className="w-full inline-flex items-center justify-center gap-2 rounded-md border border-slate-300 bg-white py-2 text-sm font-medium text-slate-700 hover:bg-slate-50 transition-colors">
          <svg viewBox="0 0 48 48" className="h-4 w-4"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z" /><path fill="#FF3D00" d="m6.3 14.7 6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" /><path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z" /><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z" /></svg>
          Entrar con Google
        </button>
        <p className="text-[11px] text-slate-400 text-center">Solo para cuentas dadas de alta en Equipo.</p>
      </form>
    </div>
  );
}
